import { useContext } from 'react'

import { ApplicantProfileContext } from '../../RentalPortalApplicantProfile.context'

export function useApplicantProfileContext() {
  return useContext(ApplicantProfileContext)
}
